import React from 'react'

import './style.scss'

export const SectionTitle = props => (
  <h2
    className={'section-title ' + props.color + ' ' + props.className}
    id={props.anchor}
  >
    {props.children}
  </h2>
)

export const ItemTitle = props => (
  <h2 className={'item-title ' + props.class}>{props.children}</h2>
)

export const SmallTitle = props => (
  <h4 className="small-title">{props.children}</h4>
)

export const Paragraph = props => (
  <p className={'paragraph-' + props.size}>{props.children}</p>
)

export const Disclaimer = props => (
  <div className="disclaimer">{props.children}</div>
)

export const Source = props => <div className="source">{props.children}</div>

export const Note = props => (
  <div className="note">
    <strong>NOTE: </strong>
    {props.children}
  </div>
)
